import React, { useState, useEffect } from "react";
import Header from "../Components/Header";
import { useNavigate } from "react-router-dom";
import Pagination from '@mui/material/Pagination';
import axios from "axios";
import { ReactSession } from 'react-client-session';
ReactSession.setStoreType("localStorage");



const Coupon = () => {
  const userId = ReactSession.get("welbeingId");
  const navigate = useNavigate();
  const [formData, setfromData] = useState({});
  const [coupon, setcoupon] = useState({});
  const [error, setError] = useState("");
  const [page, setPage] = useState(1);
  const [rowsPerPage2, setRowsPerPage2] = useState(10); // Items per page

  // Calculate total pages

  if (userId <= 0) {
    navigate('/login');
  }


  const handlePageChange = (event, newPage) => {
    event.preventDefault();
    if (newPage >= 1 && newPage <= totalPages) {
      setPage(newPage);
    }
  };


  const totalPages = Math.ceil(Array.isArray(coupon) && coupon.length / rowsPerPage2);
  const currentData = Array.isArray(coupon)
    ? coupon.slice((page - 1) * rowsPerPage2, page * rowsPerPage2)
    : [];





  const handlechange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setfromData(values => ({ ...values, [name]: value }))

  }


  const handlesubmit = async (e) => {
    e.preventDefault();
    console.log(formData);

    try {
      const response = await axios.post('https://api.welbeing.in/admin/coupon/add-coupon/', formData);
      console.log(response.data);
      if (response.data.status === "success") {
        coupons();
        navigate("/coupon");
      } else {
        console.log(response.error);
      }
    } catch (err) {
      setError(err.message);

    }
  };




  const coupons = async () => {
    try {
      const response = await axios.get('https://api.welbeing.in/admin/coupon/get-coupon/');
      console.log(response.data);
      if (response.data.status === "success") {

        setcoupon(response.data.data);
      } else {
        console.error(response.data.error?.message);
      }
    } catch (err) {
      setError(err.message);

    }
  };

  useEffect(() => {
    coupons();
  }, []);



  const handleDelete = async (id) => {
    try {
      const response = await axios.post('https://api.welbeing.in/admin/coupon/delete-coupon/', { id: id });
      console.log(response.data);
      if (response.data.status === "success") {
        coupons();
        navigate("/coupon");
      } else {
        console.log(response.error);
      }
    } catch (err) {
      setError(err.message);

    }
  }


  return (

    <>

      <Header />
      <div class="page-wrapper" id="main-wrapper" data-layout="vertical" data-sidebartype="full" data-sidebar-position="fixed" data-header-position="fixed">
        <div class="body-wrapper">
          <div class="container-fluid">
            <div class="card bg-light-info shadow-none position-relative overflow-hidden">
              <div class="card-body px-4 py-3">
                <div class="row align-items-center">
                  <div class="col-9">
                    <h4 class="fw-semibold mb-8">Coupons</h4>
                    <nav aria-label="breadcrumb">
                      <ol class="breadcrumb">
                        <li class="breadcrumb-item"><a class="text-muted" href="dashboard.php">Dashboard</a></li>
                        <li class="breadcrumb-item" aria-current="page">Coupons</li>
                      </ol>
                    </nav>
                  </div>
                  <div class="col-3">
                    <div class="text-center mb-n5">
                      <img src="dist/images/breadcrumb/ChatBc.png" alt="" class="img-fluid mb-n4" />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Main Content Section  */}
            <section>

              <div class="row">
                <div class="col-12">
                  <div class="card">
                    <div class="card-body">
                      <div class="mb-2">
                        <h5 class="mb-0"></h5>
                      </div>
                      <div class="table-responsive">
                        <section>
                          <div class="row">
                            <div class="col-lg-12">
                              <div class="card">
                                <div class="card-body">
                                  <div class="table-responsive">
                                    <form onSubmit={handlesubmit}>
                                      <div class="form-body">
                                        <div class="row">
                                          <div class="col-md-4">
                                            <div class="mb-3">
                                              <label>Coupon Code</label>
                                              <input type="text" class="form-control" name="code" placeholder="Enter coupon code" value={formData.code} onChange={handlechange} />
                                            </div>
                                          </div>
                                          <div class="col-md-4">
                                            <div class="mb-3">
                                              <label>Coupon Offer</label>
                                              <input type="text" class="form-control" name="offer" placeholder="Enter offer in %" value={formData.offer} onChange={handlechange} />
                                            </div>
                                          </div>
                                          <div class="col-md-4">
                                            <div class="mb-3">
                                              <label>Offer upto</label>
                                              <input type="text" class="form-control" name="upto" placeholder="Enter offer upto amount" value={formData.upto} onChange={handlechange} />
                                            </div>
                                          </div>
                                          <div class="col-md-4">
                                            <div class="mb-3">
                                              <label>Coupon Count</label>
                                              <input type="text" class="form-control" name="count" placeholder="Enter coupon count" value={formData.count} onChange={handlechange} />
                                            </div>
                                          </div>

                                          <div class="col-md-4">
                                            <div class="mb-3">
                                              <label>Start Date</label>
                                              <input type="date" class="form-control" name="s_date" placeholder="Offer start date" value={formData.s_date} onChange={handlechange} />
                                            </div>
                                          </div>
                                          <div class="col-md-4">
                                            <div class="mb-3">
                                              <label>End date</label>
                                              <input type="date" class="form-control" name="e_date" placeholder="Offer end date" value={formData.e_date} onChange={handlechange} />
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div class="form-actions">
                                        <div class="text-start">
                                          <button type="submit" class="btn btn-light-primary text-primary font-medium"> Submit </button>
                                        </div>
                                      </div>
                                    </form>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="col-lg-12">
                              <div class="card">
                                <div class="card-body">
                                  <div class="table-responsive" style={{ overflowX: 'auto' }}>
                                    <table class="table border">
                                      <thead class="bg-primary text-white">

                                        <tr>
                                          <th>Coupon</th>
                                          <th>Discount</th>
                                          <th>Discount Upto</th>
                                          <th>Total Count</th>
                                          <th>Sold</th>
                                          <th>Balance</th>
                                          <th>Start Date</th>
                                          <th>End Date</th>
                                          <th>Delete</th>
                                        </tr>

                                      </thead>
                                      <tbody>


                                        {currentData.map((coupon) => (
                                          <tr>
                                            <td>{coupon.coupon_code}</td>
                                            <td>{coupon.discount}%</td>
                                            <td>₹{coupon.discount}</td>
                                            <td>{coupon.Total_count}</td>
                                            <td>{coupon.sold}</td>
                                            <td>{coupon.count}</td>
                                            <td>{coupon.start_date}</td>
                                            <td>{coupon.end_date}</td>

                                            <td>
                                              <a onClick={(e) => handleDelete(coupon.id)} class="btn btn-danger bg-gradient-danger"> <i style={{ color: '#fff', fontSize: '1rem', transition: 'all 0.3s ease', cursor: 'pointer' }} className="ti ti-trash" />
                                              </a>
                                            </td>
                                          </tr>
                                        ))}

                                      </tbody>
                                    </table>


                                    {/* Pagination component */}

                                    <div className="row">
                                      <div className="col-12">
                                        <nav>
                                          <ul className="pagination justify-content-end">
                                            {/* Previous */}
                                            <li className={`page-item ${page === 1 ? 'disabled' : ''}`}>
                                              <button
                                                className="page-link"
                                                onClick={(e) => handlePageChange(e, page - 1)}
                                                disabled={page === 1}
                                              >
                                                « Previous
                                              </button>
                                            </li>


                                            {/* Visible page numbers */}
                                            {Array.from({ length: totalPages }, (_, i) => i + 1)
                                              .filter(p => p === 1 || p === totalPages || Math.abs(page - p) <= 2)
                                              .map(p => (
                                                <li key={p} className={`page-item ${page === p ? 'active' : ''}`}>
                                                  <button className="page-link" onClick={(e) => handlePageChange(e, p)}>
                                                    {p}
                                                  </button>
                                                </li>
                                              ))}

                                            {/* Show ... and last page if current page < totalPages - 2 */}
                                            {page < totalPages - 2 && (
                                              <>
                                                <li className="page-item disabled">
                                                  <span className="page-link">...</span>
                                                </li>
                                                <li className="page-item">
                                                  <button className="page-link" onClick={(e) => handlePageChange(e, totalPages)}>
                                                    {totalPages}
                                                  </button>
                                                </li>
                                              </>
                                            )}

                                            {/* Next */}
                                            <li className={`page-item ${page === totalPages ? 'disabled' : ''}`}>
                                              <button
                                                className="page-link"
                                                onClick={(e) => handlePageChange(e, page + 1)}
                                                disabled={page === totalPages}
                                              >
                                                Next »
                                              </button>
                                            </li>
                                          </ul>
                                        </nav>
                                      </div>
                                    </div>


                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </section></div>
                    </div>
                  </div>
                </div>
              </div></section>
          </div>
        </div>
      </div>
    </>
  )
}
export default Coupon;